import { render, staticRenderFns } from "./MentionStatsSummaryLinkItem.vue?vue&type=template&id=c4464302&scoped=true"
import script from "./MentionStatsSummaryLinkItem.vue?vue&type=script&lang=js"
export * from "./MentionStatsSummaryLinkItem.vue?vue&type=script&lang=js"
import style0 from "./MentionStatsSummaryLinkItem.vue?vue&type=style&index=0&id=c4464302&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4464302",
  null
  
)

export default component.exports